// extracted by mini-css-extract-plugin
export default {"txt":"Letter_txt__F5yL7","txtAnim":"Letter_txtAnim__YLwvY","displayText":"Letter_displayText__vVzPC"};